import { isDefined } from "@clipboard-health/util-ts";
import { PageHeaderWrapper, ProgressBar } from "@src/appV2/redesign/system/ui-components";

import { PageHeaderTopRow, type PageHeaderTopRowProps } from "../components/PageHeaderTopRow";
import { isRebrandingEnabled } from "../Rebranding/workerAppRebranding";

export interface OnboardingPageHeaderProps extends Pick<
  PageHeaderTopRowProps,
  "fallbackGoBackPath" | "hideBackButton" | "onClickBack"
> {
  progress: {
    current: number;
    total: number;
  };
}

export function OnboardingPageHeader(props: OnboardingPageHeaderProps) {
  const { progress, fallbackGoBackPath, hideBackButton, onClickBack } = props;

  return (
    <PageHeaderWrapper variant="tertiary">
      <PageHeaderTopRow
        title={
          isDefined(progress) ? (
            <ProgressBar
              completed={progress.current}
              showCount={false}
              total={progress.total}
              color={isRebrandingEnabled() ? "success" : undefined}
            />
          ) : undefined
        }
        fallbackGoBackPath={fallbackGoBackPath}
        hideBackButton={hideBackButton}
        // To still keep the height of the header when back button is hidden
        sx={{ minHeight: 72 }}
        onClickBack={onClickBack}
      />
    </PageHeaderWrapper>
  );
}
